export default __webpack_public_path__ + "static/media/fb_logo.2cbd97d2.png";